import ButtonDiv from '@bundles/common/ButtonDiv'
import { Redirect } from '@shopify/app-bridge/actions'
import { getAppBridgeInstance, getHost } from '@utils/appBridge'
import { Fragment, useState } from 'react'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import styled from 'styled-components'
import ModalNegative from '../components/Modal/ModalNegative'

const FeedBackIcon = () => {
  //! Props

  //! State
  const host = getHost()
  const app = host ? getAppBridgeInstance(host) : null
  const redirect = app ? Redirect.create(app) : null
  const [isShareExperience, setIsShareExperience] = useState(false)
  const [isOpenModalNegative, setIsOpenModalNegative] = useState(false)

  const data = [
    {
      id: 3,
      content: 'Negative feedback',
      icon: sadIcon,
      onAction: () => {
        setIsOpenModalNegative(true)
      },
      isShow: isShareExperience,
    },
    {
      id: 4,
      content: 'Positive feedback',
      icon: happyIcon,
      onAction: () => {
        redirect?.dispatch(Redirect.Action.APP, '/app/review')
      },
      isShow: isShareExperience,
    },
    {
      id: 1,
      content: 'Share your experience with us.',
      icon: happyIcon,
      onAction: () => setIsShareExperience(active => !active),
      isShow: true,
    }
  ]
  //! Function
  //! Effect

  //! Render
  return (
    <Fragment>
      <SWrap id="feedback-btn">
        {data
          ?.filter(el => el?.isShow)
          ?.map(el => (
            <ButtonDiv
              className={`_item ${(el?.id === 1 && isShareExperience) && '_cancel'}`}
              key={el?.id}
              data-tooltip-id={`tool-tip-icon-${el?.id}`}
              data-tooltip-content={
                el?.id === 1 && isShareExperience ? 'Close' : el?.content
              }
              data-tooltip-place="left"
              onClick={el?.onAction}
            >
              {el?.id === 1 && isShareExperience ? (
                <Fragment>
                  {cancelIcon}
                  <Tooltip id={`tool-tip-icon-${el?.id}`} />
                </Fragment>
              ) : (
                <Fragment>
                  {el?.icon}
                  <Tooltip id={`tool-tip-icon-${el?.id}`} />
                </Fragment>
              )}
            </ButtonDiv>
          ))}
      </SWrap>
      <ModalNegative
        isOpen={isOpenModalNegative}
        onClose={() => setIsOpenModalNegative(false)}
      />
    </Fragment>
  )
}

const SWrap = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 16px;
  bottom: 96px;
  right: 36px;
  z-index: 20;
  ._item{
    background: #000;
    border-radius: 100%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  ._cancel{
    animation: iconOpen 200ms;
  }
  @keyframes iconOpen {
    0%{
      opacity: 0;
      transform: rotate(-45deg);
    }
    100%{
      opacity: 1;
      transform: rotate(0deg);
    }
  }
`

const happyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.44444 4.44444C8.98421 4.44444 8.61111 4.81754 8.61111 5.27778V6.94444C8.61111 7.40468 8.98421 7.77778 9.44444 7.77778C9.90468 7.77778 10.2778 7.40468 10.2778 6.94444V5.27778C10.2778 4.81754 9.90468 4.44444 9.44444 4.44444Z"
      fill="white"
    />
    <path
      d="M5.27778 5.27778C5.27778 4.81754 5.65087 4.44444 6.11111 4.44444C6.57135 4.44444 6.94444 4.81754 6.94444 5.27778V6.94444C6.94444 7.40468 6.57135 7.77778 6.11111 7.77778C5.65087 7.77778 5.27778 7.40468 5.27778 6.94444V5.27778Z"
      fill="white"
    />
    <path
      d="M9.46878 9.98154C8.98366 10.3538 8.38926 10.5556 7.77778 10.5556C7.16629 10.5556 6.5719 10.3538 6.08677 9.98153C5.60165 9.60929 5.25291 9.08737 5.09465 8.49672C4.97553 8.05216 4.51858 7.78834 4.07403 7.90746C3.62947 8.02658 3.36565 8.48353 3.48477 8.92808C3.73799 9.87312 4.29597 10.7082 5.07217 11.3038C5.84837 11.8994 6.7994 12.2222 7.77778 12.2222C8.75615 12.2222 9.70719 11.8994 10.4834 11.3038C11.2596 10.7082 11.8176 9.87312 12.0708 8.92809C12.1899 8.48353 11.9261 8.02658 11.4815 7.90746C11.037 7.78835 10.58 8.05217 10.4609 8.49672C10.3026 9.08737 9.9539 9.60929 9.46878 9.98154Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5556 7.77778C15.5556 12.0733 12.0733 15.5556 7.77778 15.5556C3.48223 15.5556 0 12.0733 0 7.77778C0 3.48223 3.48223 0 7.77778 0C12.0733 0 15.5556 3.48223 15.5556 7.77778ZM13.8889 7.77778C13.8889 11.1529 11.1529 13.8889 7.77778 13.8889C4.4027 13.8889 1.66667 11.1529 1.66667 7.77778C1.66667 4.4027 4.4027 1.66667 7.77778 1.66667C11.1529 1.66667 13.8889 4.4027 13.8889 7.77778Z"
      fill="white"
    />
  </svg>
)

const sadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.93742 12.9897C9.27444 12.8501 9.63565 12.7782 10.0004 12.7782C10.3652 12.7782 10.7264 12.8501 11.0634 12.9897C11.4005 13.1293 11.7067 13.3339 11.9646 13.5918C12.2901 13.9172 12.8177 13.9172 13.1431 13.5918C13.4686 13.2664 13.4686 12.7387 13.1431 12.4133C12.7304 12.0006 12.2405 11.6732 11.7012 11.4499C11.162 11.2265 10.5841 11.1115 10.0004 11.1115C9.41678 11.1115 8.83884 11.2265 8.29962 11.4499C7.76039 11.6732 7.27044 12.0006 6.85774 12.4133C6.5323 12.7387 6.5323 13.2664 6.85774 13.5918C7.18317 13.9172 7.71081 13.9172 8.03625 13.5918C8.29419 13.3339 8.60041 13.1293 8.93742 12.9897Z"
      fill="white"
    />
    <path
      d="M10.8338 7.50043C10.8338 7.0402 11.2069 6.6671 11.6671 6.6671C12.1273 6.6671 12.5004 7.0402 12.5004 7.50043V9.1671C12.5004 9.62734 12.1273 10.0004 11.6671 10.0004C11.2069 10.0004 10.8338 9.62734 10.8338 9.1671V7.50043Z"
      fill="white"
    />
    <path
      d="M8.33377 6.6671C7.87353 6.6671 7.50043 7.0402 7.50043 7.50043V9.1671C7.50043 9.62734 7.87353 10.0004 8.33377 10.0004C8.794 10.0004 9.1671 9.62734 9.1671 9.1671V7.50043C9.1671 7.0402 8.794 6.6671 8.33377 6.6671Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7782 10.0004C17.7782 14.296 14.296 17.7782 10.0004 17.7782C5.70489 17.7782 2.22266 14.296 2.22266 10.0004C2.22266 5.70489 5.70489 2.22266 10.0004 2.22266C14.296 2.22266 17.7782 5.70489 17.7782 10.0004ZM16.1115 10.0004C16.1115 13.3755 13.3755 16.1115 10.0004 16.1115C6.62536 16.1115 3.88932 13.3755 3.88932 10.0004C3.88932 6.62536 6.62536 3.88932 10.0004 3.88932C13.3755 3.88932 16.1115 6.62536 16.1115 10.0004Z"
      fill="white"
    />
  </svg>
)

const cancelIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.4111 15.5906C14.7365 15.916 15.2641 15.916 15.5896 15.5906C15.915 15.2651 15.915 14.7375 15.5896 14.412L11.1788 10.0013L15.5896 5.59056C15.915 5.26512 15.915 4.73748 15.5896 4.41205C15.2641 4.08661 14.7365 4.08661 14.4111 4.41205L10.0003 8.82279L5.58958 4.41205C5.26414 4.08661 4.73651 4.08661 4.41107 4.41205C4.08563 4.73748 4.08563 5.26512 4.41107 5.59056L8.82182 10.0013L4.41107 14.412C4.08563 14.7375 4.08563 15.2651 4.41107 15.5906C4.73651 15.916 5.26414 15.916 5.58958 15.5906L10.0003 11.1798L14.4111 15.5906Z"
      fill="white"
    />
  </svg>
)

export default FeedBackIcon
